import styled from 'styled-components';

import media from '../../../theme/media';

export const MarkedListContainer = styled.ul``;
export const MarkedListItemContainer = styled.li`
    margin-bottom: 24px;
    display: flex;
    align-items: center;

    &:last-child {
        margin-bottom: 0;
    }

    ${media.desktop1920} {
        margin-bottom: 32px;
    }
`;
